import { ArrowUpRight } from "lucide-react";
import { Eyebrow, IMAGES, Reveal } from "./shared";

const INDUSTRIES = [
    "Healthcare",
    "Construction",
    "Engineering",
    "Hospitality",
    "Manufacturing",
    "Logistics",
    "Agriculture",
    "Oil & Gas",
    "Technology",
    "Security",
    "Skilled Trades",
    "Professional Services",
];

const IndustryRow = ({ name, i, bordered }) => (
    <div
        data-testid={`industry-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        className={`group flex items-baseline gap-6 border-t border-ink/10 px-2 py-4 transition-colors duration-300 hover:bg-ivory sm:py-5 ${
            bordered ? "" : i === INDUSTRIES.length - 1 ? "border-b" : ""
        }`}
    >
        <span className="w-8 shrink-0 text-xs font-medium tracking-widest text-ink/35 transition-colors duration-300 group-hover:text-champagne">
            {String(i + 1).padStart(2, "0")}
        </span>
        <span className="font-serif text-2xl font-medium tracking-tight text-ink/85 transition-transform duration-300 group-hover:translate-x-2 group-hover:text-forest sm:text-3xl">
            {name}
        </span>
        <ArrowUpRight
            size={18}
            strokeWidth={1.5}
            className="ml-auto shrink-0 self-center text-forest opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        />
    </div>
);

export const Industries = ({
    intro = "From hospitals to construction sites, we understand the people each sector depends on — and where to find them.",
    layout = "list",
}) => (
    <section id="industries" data-testid="industries-section" className="bg-sand py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid gap-14 lg:grid-cols-12 lg:gap-20">
                <div className="lg:col-span-5">
                    <div className="lg:sticky lg:top-32">
                        <Reveal>
                            <Eyebrow>Industries</Eyebrow>
                            <h2 className="mt-5 font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                                Talent Across Major Industries
                            </h2>
                            <p className="mt-6 max-w-md text-base leading-relaxed text-ink/65">{intro}</p>
                        </Reveal>
                        <Reveal delay={0.15} className="mt-12">
                            <div className="group overflow-hidden">
                                <img
                                    src={IMAGES.industries}
                                    alt="African healthcare professional in a clinical setting"
                                    loading="lazy"
                                    className="aspect-[4/5] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                                />
                            </div>
                        </Reveal>
                    </div>
                </div>

                <div className="lg:col-span-7">
                    <Reveal>
                        {layout === "grid" ? (
                            <div
                                data-testid="industries-list"
                                className="grid border-b border-ink/10 sm:grid-cols-2 sm:gap-x-12"
                            >
                                {INDUSTRIES.map((name, i) => (
                                    <IndustryRow key={name} name={name} i={i} bordered />
                                ))}
                            </div>
                        ) : (
                            <div data-testid="industries-list">
                                {INDUSTRIES.map((name, i) => (
                                    <IndustryRow key={name} name={name} i={i} />
                                ))}
                            </div>
                        )}
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
